export default __webpack_public_path__ + "static/media/CNo.75-5.2de2e4f3.jpg";